import {Vue, Component} from 'vue-property-decorator';
import { Observer } from "mobx-vue";

import BroadcastFlow from '@/components/BroadcastFlow';
import SuspendedBall from '@/components/SuspendedBall';
import Menu from '@/components/SuspendedBall/Menu';
import Dialog from '@/components/Dialog';
import RestoreAndRestart from '@/components/Dialog/RestoreAndRestart';
import Loading from '@/components/Loading';
import Log  from '@/components/Log';

import GlobalStore from '@/store/GlobalStore';
import HomeStore from '@/store/HomeStore';
import DevicePlayStore from '@/store/DevicePlayStore';

@Observer
@Component
export default class DevicePlay  extends Vue {

  constructor(props: any) {
    super(props)
  }

  state = {
    GlobalStore,
    HomeStore,
    DevicePlayStore
  }
  async created() {
      this.state.DevicePlayStore.init()
  }
  async mounted () {

  }
  beforeDestroy () {
    this.state.DevicePlayStore.cloudplayStopSDK(null)
    this.state.DevicePlayStore.init()
  }


  render() {
    return (
      <div>
        <Log type='hooks' number='N0901'/>
        <Loading
          routerPushHome={this.state.DevicePlayStore.routerPushHome}
          error={this.state.DevicePlayStore.error}
          errorText={this.state.DevicePlayStore.errorText}
          visibility={this.state.DevicePlayStore.loadingVisibility} />
        
        <BroadcastFlow
          events={{
            initSdk: this.state.DevicePlayStore.initSdk,
            startSdk: this.state.DevicePlayStore.startSdk
          }}
        />
        
        <SuspendedBall tap={() => this.state.DevicePlayStore.setMenuVisibility(true)} />
        
        <Menu
          data={{
            resolutionList: this.state.DevicePlayStore.resolutionList,
            currentResolution: this.state.DevicePlayStore.currentResolution,
            pkgName: this.state.HomeStore.cloudDevicePlayInfo.pkgName
          }}
          events={{
            cloudplayHome: this.state.DevicePlayStore.cloudplayHome,
            cloudplayMeun: this.state.DevicePlayStore.cloudplayMeun,
            cloudplayBackspace: this.state.DevicePlayStore.cloudplayBackspace,
            cloudplayResolutionPhone: this.state.DevicePlayStore.cloudplayResolutionPhone,
            cloudplayExit: this.state.DevicePlayStore.setModalVisibility,
            setMenuVisibility: this.state.DevicePlayStore.setMenuVisibility
          }}
          visibility={this.state.DevicePlayStore.menuVisibility} />
        
        <Dialog
          visible={this.state.DevicePlayStore.modalVisibility}
          cancel={() => this.state.DevicePlayStore.setModalVisibility( false)}
          ok={() =>this.state.DevicePlayStore.cloudplayStopSDK('devicePlay')}>
          <RestoreAndRestart type={0}>
           您确定要退出云手机吗?
          </RestoreAndRestart>
        </Dialog>
        
      </div>
    )
  }
  
}